/* eslint-disable indent */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable operator-linebreak */
/* eslint-disable max-len */
import { Dispatch } from 'redux';
import { IPayStub } from 'src/interfaces';
import paymentsService from 'src/services/payments.service';

import { PaymentsActionType } from '../action-types';
import { PaymentsAction } from '../actions';

export const getPayments = (initialDate: string, finalDate: string) => async (dispatch: Dispatch<PaymentsAction>) => {
  dispatch({
    type: PaymentsActionType.GET_PAYMENTS,
  });

  try {
    const { data }: { data: IPayStub[] } = await paymentsService.getPayStubs(initialDate, finalDate);

    dispatch({
      type: PaymentsActionType.GET_PAYMENTS_SUCCESS,
      payload: { payments: data },
    });
  } catch (err: any) {
    dispatch({
      type: PaymentsActionType.GET_PAYMENTS_FAILURE,
      payload: err.message,
    });
  }
};
